









































































































import Vue from 'vue'
import { uploadPOST } from '@/api/api'
import dayjs from 'dayjs'
import * as _ from 'lodash'
import {
  TransferDirectoryFileServiceProxy,
  FolderServiceProxy,
} from '@/service-proxies/app-v2/dnc.service-proxies'
import { deepClone } from '@/utils'

import { ServiceProxy as ObsFileServiceProxy } from '@/service-proxies/app-v2/resource.service-proxies'

const transferDirectoryFileServiceProxy = new TransferDirectoryFileServiceProxy()
const ofsp = new ObsFileServiceProxy()
const fsp = new FolderServiceProxy()

const arrayToTree = (groupMap, arr) => {
  if(!arr || !arr.length) {
    return
  }
  arr.map(item=>{
    let children = groupMap[item.id] || []
    if(children.length&&item.children) {
      item.children.push(...children)
    }
    arrayToTree(groupMap, children)
  })
  return arr
}

export default Vue.extend({
  name: 'UploadFile',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    checkedDirectoryIds: { // 选中的工位文件Id集合
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      loading: false,
      fileRecords: {
        programs: [],
        documents: []
      },
      selectOringinVisible: false,
      fileTreeVisible: false,
      treeFiles: [] as any, // 选中的文档
      treeData: [] as any, // 文档目录
      originalFiles: [] as any,
      fileTypes: {
        1: 'programs',
        2: 'documents'
      },
      currentfileType: 1,
      validateFile: true,
      searchValue: '',
      expandedKeys: [],
      autoExpandParent: true,
      dataList: []
    }
  },
  computed: {
    uploadGroup() {
      return [
        {
          title: this.$t('page_my_document_program'),
          label: this.$t('page_my_document_addprogram'),
          type: 1
        },
        {
          title: this.$t('page_my_document_process'),
          label: this.$t('page_my_document_addprocess'),
          type: 2
        }
      ]
    }
  },
  watch: {
    visible: {
      handler(val) {
        if (val) {
          this.loading = false
          this.fileRecords = {
            programs: [],
            documents: []
          }
        }
      },
      immediate: true
    },
    fileTreeVisible(val) {
      if (val) {
        this.treeData = [{ title: this.$t('page_resource_pool_my_doc'), key: 0, checkable: false }]
        this.originalFiles = []
        this.treeFiles = []
      }
    }
  },
  created() {
    this.treeData = [{ title: this.$t('page_resource_pool_my_doc'), key: 0, checkable: false }]
  },
  methods: {
    // 加载我的文档树数据
    /*loadTreeData(treeNode) {
      return new Promise(resolve => {
        if (treeNode.dataRef.children) {
          resolve()
          return
        }
        fsp.folderList(treeNode.dataRef.key, '').then(res => {
          this.originalFiles = [...res.fileList]
          let files, folders
          files = res.fileList.map(file => ({ title: file.name, key: file.id, isLeaf: true }))
          folders = res.folderList.map(folder => ({ title: folder.name, key: folder.id, checkable: false }))
          treeNode.dataRef.children = [...files, ...folders]
          this.treeData = [...this.treeData]
          resolve()
        })
      })
    },*/
    getLeaf(data) {
      return {
        title: data.name,
        key: data.id,
        isLeaf: true,
        ...data
      }
    },
    // 文件夹与文件夹归类
    handler(data, arrMap) {
      data.map(item => {
        if (item.children && item.children.length) {
          this.handler(item.children)
        }
        if (arrMap && arrMap[item.id]) {
          arrMap[item.id].map(item1 => {
            item.children.push(item1)
          })
        }
      })
      return data
    },
    async getTreeData() {
      this.treeData = []
      let res = await fsp.folderAllList()
      let files = [], folders = [], folderGroups = [], arrMap = {}
      if (res) {
        this.originalFiles = [...res.fileList]
        this.dataList = [...res.folderList]
        res.fileList.map(file => {
          let leaf = this.getLeaf(file)
          if (file.parentId === '0') {
            files.push(leaf)
          }
        })

        res.folderList.map(folder=>{
          if (folder.parentId !== '0') {
            arrMap[folder.parentId] = []
          }
        })

        // 文件归类于文件夹
        if (res.folderList.length) {
          res.folderList.map(folder => {
            let node = {
              title: folder.name,
              key: folder.id,
              checkable: false,
              ...folder,
              children: [],
              scopedSlots: { title: 'title' }
            }
            res.fileList.map(file => {
              let leaf = this.getLeaf(file)
              if (file.parentId === folder.id) {
                node.children.push(leaf)
              }
            })
            if (folder.parentId !== '0') {
              arrMap[folder.parentId].push(node)
            }
            folders.push(node)
          })

          folderGroups = this.handler(folders, arrMap)

          // 文件夹去重,先记录需要删除的文件夹的反向下标
          let deleteIndexGroup = []
          Object.keys(arrMap).map(k => {
            folderGroups.slice(0).reverse().map((item, i, arr) => {
              if (item.parentId === k) {
                deleteIndexGroup.push(arr.length - i - 1)
                // folderGroups.splice(arr.length - i - 1, 1)
              }
            })
          })
          // 反向下标按从大到小排序
          deleteIndexGroup.sort((a,b)=>{
            return b - a
          })
          // 按从后往前的顺序删除重复的文件夹
          deleteIndexGroup.forEach(i=>{
            folderGroups.splice(i, 1)
          })
        }
        this.treeData = [...files, ...folderGroups]
        console.log('tree data====>', files, arrMap, folderGroups, this.dataList)
      }
    },
    // 打开文件源选择框
    openOriginSelectModal(type: number) {
      this.currentfileType = type
      this.selectOringinVisible = true
    },
    // 打开我的文档树选框
    openTreeUpload() {
      this.selectOringinVisible = false
      this.fileTreeVisible = true
      this.getTreeData()
     /* this.$nextTick(() => {
        const tree = this.$refs.aTree.$el
        const firstNode: any = tree.getElementsByClassName('ant-tree-switcher')
        if (firstNode[0]) {
          firstNode[0].click()
        }
      })*/
    },
    // 上传我的文档中选中的文件
    handleTreeUpload() {
      const files = this.originalFiles
        .filter(item => {
          return this.treeFiles.includes(item.id)
        })
        .map(item => {
          return {
            contentLength: item.contentLength,
            contentMd5: item.contentMd5,
            contentType: item.contentType,
            filename: item.objectKey,
            originalFilename: item.name,
            objectKey: item.objectKey,
            suffix: item.suffix,
            lastModified: dayjs(item.updateTime).format('YYYY-MM-DD HH:mm:ss'),
            fileType: this.currentfileType,
            fileSource: 1
          }
        })

      const filterFiles = []
      for (let f of files) {
        const flag = this.fileRecords[this.fileTypes[this.currentfileType]].find(item => item.contentMd5 === f.contentMd5)
        if (!flag) {
          filterFiles.push({ ...f })
        }
      }
      this.fileRecords[this.fileTypes[this.currentfileType]] = [...this.fileRecords[this.fileTypes[this.currentfileType]], ...filterFiles]
      this.fileTreeVisible = false
    },
    // 上传：方法二
    uploadFile(file: any) {
      this.selectOringinVisible = false
      // console.log('上传文件', file.file)
      let uid = file.file.uid
      let targetFile = file.file
      let fileSuffix = targetFile.name.lastIndexOf(".") > 0 ? targetFile.name.substring(targetFile.name.lastIndexOf(".") + 1) : ""

      this.loading = true
      const formData = new FormData()
      formData.append('file', file.file)
      uploadPOST(formData).then(async(res: any) => {
        // console.log('上传文件结果:', res.data.data)
        if (res.data.data) {
          let data = res.data.data

          const ossfile = await (await ofsp.statFileUsingGET(data.name)).data

          // fileSource: 文件来源 0：本地文档 1：非资源 2：资源 4：回传文件;  fileType 1：加工文件  2：工艺文件
          Object.assign(data, {
            fileSource: 0,
            fileType: this.currentfileType,
            contentLength: ossfile.length,
            contentMd5: ossfile.hash,
            contentType: ossfile.contentType,
            originalFilename: data.originalName,
            objectKey: data.name,
            suffix: fileSuffix
          })

          // fileSource: 文件来源  0: 本地上传  1：非资源  2：资源 4：回传文件 ; fileType 1：加工文件  2：工艺文件
          Object.assign(data, { fileSource: 0, fileType: this.currentfileType })
          // 上传成功
          this.fileRecords[this.fileTypes[this.currentfileType]].map(item => {
            if (item.uid && item.uid === uid) {
              Object.assign(item, data)
            }
          })
        }
        // console.log(this.fileRecords)
      }, (err: any) => {
        // 上传失败，从列表移除
        let index = this.fileRecords[this.fileTypes[this.currentfileType]].findIndex(item => item.uid === uid)
        this.fileRecords[this.fileTypes[this.currentfileType]].splice(index, 1)
        this.$message.error(this.$t('page_transport_directory_upload_failed'))
      }).finally(() => {
        this.fileRecords = _.cloneDeep(this.fileRecords)
        this.loading = false
      })
    },
    // 上传的文件状态改变时，添加，删除
    handleChange(info: any) {
      // console.log('change:', info)
      if (!this.validateFile) {
        return
      }

      // 同类型下，过滤同名
      const index = this.fileRecords[this.fileTypes[this.currentfileType]].findIndex(item => item.name === info.file.name)
      if (index > -1) {  // 有重复文件，覆盖
        this.fileRecords[this.fileTypes[this.currentfileType]].splice(index, 1, info.file)
      } else { // 未重复，直接添加
        this.fileRecords[this.fileTypes[this.currentfileType]].push(info.file)
      }
    },
    removeFile(objectKey: any, fileType: number) {
      // 从列表删除
      let index = this.fileRecords[this.fileTypes[fileType]].findIndex(file => file.objectKey === objectKey)
      this.fileRecords[this.fileTypes[fileType]].splice(index, 1)
      // 从接口删除
      ofsp.removeFileUsingPOST(objectKey)
    },
    // 上传之前的校验
    beforeUpload(file: any) {
      // console.log('beforeUpload:', file)
      let isLt = null

      // 单位MB
      isLt = file.size / 1024 / 1024 < 20
      this.validateFile = isLt
      if (!isLt) {
        // 校验失败，更改文件上传的状态为error；并传入fileType，方便删除时使用
        // Object.assign(file, { status: 'error', fileType: this.currentfileType })
        this.$message.error(
          `${this.$t('page_transport_directory_upload_limit')} 20MB!`
        )
      }
      return isLt
    },
    // 文件保存到所有勾选的目录内
    handleOk() {
      this.loading = true
      let params = []
      const fileList = [...this.fileRecords.documents, ...this.fileRecords.programs]
      this.checkedDirectoryIds.map(dir => {
        fileList.map(file => {
          let character = {
            contentLength: file.contentLength,
            contentMd5: file.contentMd5,
            contentType: file.contentType,
            fileSource: file.fileSource,
            fileType: file.fileType,
            filename: file.filename,
            lastModified: file.lastModified,
            objectKey: file.objectKey,
            originalFilename: file.originalFilename,
            suffix: file.suffix,
            transferDirectoryId: dir
          }
          params.push(character)
        })
      })
      transferDirectoryFileServiceProxy.save(params).then((res: any) => {
        this.$emit('close', true)
      }).finally(() => {
        this.loading = false
      })
    },
    handleCancel() {
      this.$emit('close')
    },
    onExpand(expandedKeys) {
      this.expandedKeys = expandedKeys
      this.autoExpandParent = false
    },
    getParentKey(key, tree) {
      let parentKey
      for (let i = 0; i < tree.length; i++) {
        const node = tree[i]
        if (node.children) {
          if (node.children.some(item => item.key === key)) {
            parentKey = node.key
          } else if (this.getParentKey(key, node.children)) {
            parentKey = this.getParentKey(key, node.children)
          }
        }
      }
      return parentKey
    },
    onChange(e) {
      const value = e.target.value
      const expandedKeys = this.dataList
        .map(item => {
          if (item.name.indexOf(value) > -1) {
            return this.getParentKey(item.id, this.treeData)
          }
          return null
        })
        .filter((item, i, self) => item && self.indexOf(item) === i)
      Object.assign(this, {
        expandedKeys,
        searchValue: value,
        autoExpandParent: true
      })
    }
  }
})
